/**
 * Loads the environment variables
 * from meta.env and returns them as an object
 * @returns {Object} - The environment variables
 */
const loadEnv = () => {
  const env = import.meta.env
  const {
    VITE_AUTH0_API_AUDIENCE,
    VITE_AUTH0_CLIENT_ID,
    VITE_AUTH0_DOMAIN,
    VITE_AUTH0_ORG,
    VITE_UPLOAD_URL,
    VITE_EVENT_STREAM_TIMEOUT,
    VITE_DISABLE_AUTH0,
    VITE_SUPABASE_URL,
    VITE_SUPABASE_ANON_KEY,
  } = env
  return {
    authDisabled: VITE_DISABLE_AUTH0 === 'true',
    uploadURL: VITE_UPLOAD_URL,
    auth0ClientId: VITE_AUTH0_CLIENT_ID,
    auth0Domain: VITE_AUTH0_DOMAIN,
    auth0Audience: VITE_AUTH0_API_AUDIENCE,
    auth0Org: VITE_AUTH0_ORG,
    eventStreamTimeout: VITE_EVENT_STREAM_TIMEOUT || 1000,
    supabaseUrl: VITE_SUPABASE_URL,
    supabaseAnonKey: VITE_SUPABASE_ANON_KEY,
  }
}
export const Env = loadEnv()
